import React from 'react'

const IconACSignals = ({ width = '24px', height = '24px', color = '#689E77' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14"
    ></path>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M15 22a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
    ></path>
  </svg>
)

export default IconACSignals
